import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@workspace/ui/components/card'
import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { FullScreenState } from '@workspace/ui/components/full-screen-state'
import { useEffect, useState } from 'react'
import { useAppContext } from '../../../contexts/app-guard'
import { auth } from '../../../lib/auth'
import { trackEvent } from '../../../lib/gtag'
import { authorizeUrl, readOAuthQuery } from '../lib/oauth-api'

/**
 * Where an assistant's OAuth request lands once the studio's own sign-in has run. An investor goes
 * straight back to the server with the same signed request, which moves on to the consent page;
 * anyone else can switch account.
 */
export function OAuthContinue() {
  const { oauthQuery } = readOAuthQuery()
  const { user } = useAppContext()
  const [switching, setSwitching] = useState(false)
  const isInvestor = user.userType === 'INVESTOR'

  useEffect(() => {
    if (isInvestor && oauthQuery) window.location.replace(authorizeUrl(oauthQuery))
  }, [isInvestor, oauthQuery])

  if (!oauthQuery) {
    return (
      <FullScreenState
        title="This link is not valid"
        subtitle="Start again from your AI assistant."
      />
    )
  }
  if (isInvestor) return <FullScreenState loading title="Connecting..." />

  const switchAccount = async () => {
    trackEvent('oauth_account_switch_clicked', { step: 'sign_in' })
    setSwitching(true)
    await auth.signOut()
    window.location.reload()
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>This connection is for investor accounts</CardTitle>
          <CardDescription>You are signed in as a founder or admin account.</CardDescription>
        </CardHeader>
        <CardContent>
          <CtaButton className="w-full" loading={switching} onClick={switchAccount}>
            Sign in with a different account
          </CtaButton>
        </CardContent>
      </Card>
    </div>
  )
}
